import React from 'react'
import { HeadLayout } from './head-layout'
import PropTypes from 'prop-types'

export function HeadWithPolyfills (props) {
  return (
    <HeadLayout title={props.title} />
  )
}

HeadWithPolyfills.propTypes = {
  title: PropTypes.string.isRequired
}
